import * as React from "react";
import { SVGProps } from "react";

const Maidsafecoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1984 2209" {...props}>
    <path
      fill="#99bee7"
      d="M1598.1 730.3V2209L348.5 1483.4C-18.4 1272.2 9.1 1134.4 0 840.5l1285.5 744V904.8l312.3-174.5h.3z"
    />
    <path
      fill="#5592d7"
      d="M1285.5 1584.5 0 840.5 1249.1 124c367.1-211.1 468.4-119.2 734.7 28.2L698 895.6l587.5 339.9v349z"
    />
    <path
      fill="#29578a"
      d="m698 895.6 1286.3-743.5v1433.1c0 431.7-129 468.4-385.8 624.5V730.3L1013 1078.2 698 895.6z"
    />
  </svg>
);

export default Maidsafecoin;
